import type { GetCompanyDomainData } from 'api/dist/routes/organization/[organization_id]/company-domain/index.js'
import type { IApi } from '@/setup/api-client'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { useApiQuery } from '@/utils/api/api-query'

interface IGetCompanyDomainParams {
    organizationId: string
}

export type ICompanyDomain = GetCompanyDomainData

/** Minimal React Query refresh result consumed by the company-domain verification flow. */
export interface ICompanyDomainRefreshResult {
    data?: ICompanyDomain
    isError: boolean
    isSuccess: boolean
}

/** Reads the active workspace's company domains directly from Clerk through the API. */
export class GetCompanyDomainQuery {
    static getKey(params: IGetCompanyDomainParams) {
        return ['organization', params.organizationId, 'company-domain']
    }

    static call(api: IApi, params: IGetCompanyDomainParams) {
        return api
            .get<GetCompanyDomainData>(`/organization/${params.organizationId}/company-domain`)
            .then((response) => response.data)
    }
}

/** Returns Clerk's live company-domain state when the user may view it. */
export function useGetCompanyDomainQuery() {
    const { api, apiParams } = useApiToolbox()

    return useApiQuery({
        queryKey: GetCompanyDomainQuery.getKey(apiParams),
        queryFn: () => GetCompanyDomainQuery.call(api, apiParams),
        enabled: !!apiParams.organizationId,
        staleTime: 0,
        refetchOnMount: 'always',
    })
}
